
<template>
  <div class="predictor">
    <div>
      <div class="home backimg">
        <img style="color: white;" src="./assets/BYRD_AI_horizontal_white.png">
      </div>
    </div>
    <div class="container-fluid">
      <div>
        <b-navbar class="navbar bg-custom" type="light" toggleable fixed="top">
          <b-navbar-nav
            v-scroll-spy-link
            v-scroll-spy-active="{class: 'customActive'}"
            style="display: inline-block;"
          >
            <!--b-nav-item href="#">Home</b-nav-item-->
            <b-nav-item href="#">Bilderkennung</b-nav-item>
            <b-nav-item href="#">Texterkennung</b-nav-item>
            <b-nav-item href="#">Bild + Text</b-nav-item>
          </b-navbar-nav>
        </b-navbar>
      </div>
      <br />
      <br />
      <div class="container-fluid" v-scroll-spy="{ offset: 75 }">
        <div class="container-fluid">
          <SingleImgPred />
        </div>
        <div class="container-fluid">
          <TextPred />
        </div>
        <div class="excel-pred">
          <ExcelPred />
        </div>
      </div>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import scrollactive from "./components/AppHeader.vue";
import AppHeader from "./components/AppHeader.vue";
import AppFooter from "./components/AppFooter.vue";
import AppHome from "./components/AppHome.vue";
import SingleImgPred from "./components/SingleImgPred.vue";
import TextPred from "./components/TextPred.vue";
import ExcelPred from "./components/ExcelPred.vue";

export default {
  name: "app",
  components: {
    AppHeader,
    AppFooter,
    AppHome,
    SingleImgPred,
    TextPred,
    ExcelPred
  },
  methods: {
    // Convenience method to scroll a heading into view.
    // Not required for scrollspy to work
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    }
  },
  data() {
    return {
      section: 0
    };
  }
};
</script>


<style>
.predictor {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

.main {
  margin-left: 50px;
  margin-right: 50px;
}
h3 {
  margin: 40px 0 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #0bd2c5;
}

.progress-bar {
  color: #0bd2c5;
}

.bc-success {
  background-color: #0bd2c5!important;
}

.menu {
  padding: 0;
  list-style: none;
}

.menu-item {
  margin-bottom: 20px;
}

.menu-item a {
  cursor: pointer;
}

.customActive {
  color: #f4f4f4;
  /*border-left: 1px solid #09c171;*/
  padding-left: 5px;
  transition: all 0.5s;
}
.navbar-light .navbar-nav .nav-link {
  color: #0bd2c5 !important;
}
.bg-custom {
  background-color: #4a4a4ae6 !important;
}
.backimg {
  background-image: url("./assets/home.jpg");
  background-attachment: fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: 100% 100%;
  padding-bottom: 140px;
  padding-top: 100px;
  background-color: rgba(122, 122, 122, 0.5);
}
</style>
